var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElement9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 16,
    viewBox: "0 0 69 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01904 0H7.2177C3.23148 0 0 3.18436 0 7.11246V8.88754C0 12.8156 3.23148 16 7.2177 16H9.01904C13.0053 16 16.2367 12.8156 16.2367 8.88754V7.11246C16.2367 3.18436 13.0053 0 9.01904 0Z",
    fill: "#FF7C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3975 0H33.5961C29.6099 0 26.3784 3.18436 26.3784 7.11246V8.88754C26.3784 12.8156 29.6099 16 33.5961 16H35.3975C39.3837 16 42.6152 12.8156 42.6152 8.88754V7.11246C42.6152 3.18436 39.3837 0 35.3975 0Z",
    fill: "#FF7C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7759 0H59.9745C55.9883 0 52.7568 3.18436 52.7568 7.11246V8.88754C52.7568 12.8156 55.9883 16 59.9745 16H61.7759C65.7621 16 68.9936 12.8156 68.9936 8.88754V7.11246C68.9936 3.18436 65.7621 0 61.7759 0Z",
    fill: "#FF7C3D"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement9);
export default __webpack_public_path__ + "static/media/element9.e05d8b81d012ea43b1054e9c6ed5e003.svg";
export { ForwardRef as ReactComponent };